// extracted by mini-css-extract-plugin
export default {"container":"index_container__QoskR","title":"index_title__RL-4o","titleRed":"index_titleRed__gdSXL","titleBlack":"index_titleBlack__4rfKA","subtitle":"index_subtitle__GQOYQ"};